'use client';
import { jsx, jsxs } from "react/jsx-runtime";
import "react";
const UnreadOffersCount = ({ unreadOffersCount })=>unreadOffersCount > 0 && /*#__PURE__*/ jsx("div", {
        className: "ptw-mr-3 ptw-flex ptw-flex-1 ptw-justify-end",
        children: /*#__PURE__*/ jsxs("div", {
            style: {
                backgroundColor: '#E91C24'
            },
            className: "ptw-flex ptw-size-fit ptw-h-[28px] ptw-w-[28px] ptw-items-center ptw-justify-center ptw-rounded-pill ptw-font-bold ptw-text-primary-text",
            "aria-label": unreadOffersCount > 99 ? '99+ unread messages' : unreadOffersCount + ' unread messages',
            children: [
                unreadOffersCount > 99 ? '99+' : unreadOffersCount,
                /*#__PURE__*/ jsx("span", {
                    className: "ptw-sr-only",
                    children: " unread messages"
                })
            ]
        })
    });
const UnreadOffers_UnreadOffersCount = UnreadOffersCount;
export { UnreadOffers_UnreadOffersCount as default };
